export default __webpack_public_path__ + "static/media/claudia-christian-headshot-blue-front.b9f1fce3.png";